import { motion } from "framer-motion";
import { IMAGES } from "@/lib/site";

export default function About() {
  return (
    <section
      id="sobre"
      data-testid="about-section"
      className="py-24 md:py-36 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 md:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, ease: "easeOut" }}
            className="lg:col-span-5 relative"
          >
            <div className="relative aspect-[3/4] w-full bg-neutral-100 overflow-hidden">
              <img
                src={IMAGES.aboutPortrait}
                alt="Bianca Sena"
                className="absolute inset-0 w-full h-full object-cover"
                loading="lazy"
              />
            </div>
            <div className="absolute -top-6 -right-6 hidden md:block">
              <span className="font-serif italic text-7xl text-black/10">B.S.</span>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, ease: "easeOut" }}
            className="lg:col-span-7 lg:pl-8"
          >
            <p className="text-[11px] tracking-[0.3em] uppercase text-neutral-500 mb-6 flex items-center gap-3">
              <span className="inline-block h-px w-10 bg-neutral-400" />
              Quem sou eu
            </p>

            <div className="space-y-6 text-lg md:text-2xl text-neutral-700 font-serif font-light leading-snug max-w-2xl">
              <p>
                Meu nome é <span className="text-black">Bianca</span>, sou
                designer de sobrancelha e micropigmentadora há 2 anos, a minha
                especialidade é{" "}
                <em className="italic text-black">sobrancelhas naturais</em>.
              </p>
              <p>
                Meu objetivo é destacar a sua beleza com elegância, delicadeza
                e resultados personalizados.
              </p>
            </div>

            <div className="mt-12 max-w-xs">
              <div className="border-l border-black/20 pl-5">
                <div className="text-[10px] tracking-[0.3em] uppercase text-neutral-500 mb-2">
                  Filosofia
                </div>
                <div className="font-serif text-2xl text-black leading-tight">
                  Naturalidade
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
